/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompleteTaskRequest
 */
export interface CompleteTaskRequest {
    /**
     * 
     * @type {string}
     * @memberof CompleteTaskRequest
     */
    taskId: string;
    /**
     * 
     * @type {CompleteTaskRequestActionEnum}
     * @memberof CompleteTaskRequest
     */
    action?: CompleteTaskRequestActionEnum;
    /**
     * 
     * @type {string}
     * @memberof CompleteTaskRequest
     */
    formData?: string;
    /**
     * 
     * @type {string}
     * @memberof CompleteTaskRequest
     */
    distributionAssignee?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CompleteTaskRequest
     */
    delegateSelection?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CompleteTaskRequest
     */
    comment?: string;
}


/**
 * @export
 */
export const CompleteTaskRequestActionEnum = {
    Approved: 'approved',
    Rejected: 'rejected',
    RequestClarification: 'request clarification'
} as const;
export type CompleteTaskRequestActionEnum = typeof CompleteTaskRequestActionEnum[keyof typeof CompleteTaskRequestActionEnum];


/**
 * Check if a given object implements the CompleteTaskRequest interface.
 */
export function instanceOfCompleteTaskRequest(value: object): value is CompleteTaskRequest {
    if (!('taskId' in value) || value['taskId'] === undefined) return false;
    return true;
}

export function CompleteTaskRequestFromJSON(json: any): CompleteTaskRequest {
    return CompleteTaskRequestFromJSONTyped(json, false);
}

export function CompleteTaskRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompleteTaskRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'taskId': json['taskId'],
        'action': json['action'] == null ? undefined : json['action'],
        'formData': json['formData'] == null ? undefined : json['formData'],
        'distributionAssignee': json['distributionAssignee'] == null ? undefined : json['distributionAssignee'],
        'delegateSelection': json['delegateSelection'] == null ? undefined : json['delegateSelection'],
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}

export function CompleteTaskRequestToJSON(json: any): CompleteTaskRequest {
    return CompleteTaskRequestToJSONTyped(json, false);
}

export function CompleteTaskRequestToJSONTyped(value?: CompleteTaskRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'taskId': value['taskId'],
        'action': value['action'],
        'formData': value['formData'],
        'distributionAssignee': value['distributionAssignee'],
        'delegateSelection': value['delegateSelection'],
        'comment': value['comment'],
    };
}

